import React from "react";

import DataTable from "components/basic/data-table/DataTable";
import { TableColumn } from "components/pages/measurement-devices/utils/types";
import { Button } from "primereact/button";
import { DatasetsSearchResult } from "types/types";
import { DEFAULT_DASHBOARD_URL, HASH_ROUTER_URL } from "utils/constants";
import { T } from "services/lang/LanguageService";

type DashboardResult = Omit<DatasetsSearchResult, "task">

type DashboardResultTableProps = {
  results: DashboardResult[];
  loading?: boolean;
};

const DashboardResultTable: React.FC<DashboardResultTableProps> = ({ results, loading }) => {
  
  const renderLink = (rowData: DashboardResult) => {
    if (rowData.resultFound === "DASHBOARD") {
      return (
        <Button
          icon="pi pi-external-link"
          className="p-button-sm p-button-text p-1"
          style={{ width: "1.3rem" }}
          onClick={() =>
            window.open(
              `${HASH_ROUTER_URL}/dashboard/${rowData.dashboard.id}/tab/${rowData.dashboard.tabId}`
            )
          }
        />
      );
    }
    const url = `${DEFAULT_DASHBOARD_URL}dashboardId=${rowData.dashboard.id}&tabId=${rowData.dashboard.tabId}&dashboard=${rowData.dashboard.dashboardTitle}`;
    return (
      <Button
        icon="pi pi-external-link"
        className="p-button-sm p-button-text p-1"
        style={{ width: "1.3rem" }}
        onClick={() => window.open(url)}
      />
    );
  };

  const dashboardColumns: TableColumn<DashboardResult>[] = [
    {
      field: "dashboard.dashboardTitle",
      header: T("word.dashboard-title"),
      columnKey: "dashboardTitle",
    },
    {
      field: "dashboard.tabTitle",
      header: T("word.tab-title"),
      columnKey: "tabTitle",
    },
    {
      field: "dashboard.componentTitle",
      header: T("word.component-or-group-title"),
      columnKey: "componentTitle",
    },
    {
      header: "Link",
      columnKey: T("word.link"),
      body: renderLink,
    },
  ];


  return (
    <DataTable
    data={results}
    columns={dashboardColumns}
    tableConfig={{ loading }}
  />
  )
}

export default DashboardResultTable;